import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Separator } from './ui/separator';

const Contact = () => {
  return (
    <section className="py-12 md:py-16">
      <Separator className="mb-12 md:mb-16 bg-border" />
      
      <nav className="flex flex-wrap gap-8 md:gap-12">
        <a
          href="https://linkedin.com/in/aldocoria"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          LinkedIn
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>
        
        <a
          href="https://x.com/aldohcoria"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          X
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>

        <a
          href="https://foundation.app/@commodore64"
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          NFT
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>
        
        {/* Usamos el email corporativo para la ronda */}
        <a
          href="mailto:aldo@enabl.ai"
          className="group inline-flex items-center gap-1 font-sans text-base md:text-lg text-foreground hover:text-muted-foreground transition-colors duration-200"
        >
          Email
          <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-200" />
        </a>
      </nav>
      <footer className="py-12 md:py-16 pb-24">
            <div className="flex items-center gap-2 group">
              <p className="text-muted-foreground/60 dark:text-white/30 font-mono text-[10px] tracking-widest uppercase transition-colors">
                Based in Spain. Building for the world. ©{new Date().getFullYear()}
              </p>
              
              <div className="relative flex items-center justify-center">
                <svg 
                  width="14" 
                  height="14" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="1.2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className="text-muted-foreground/40 dark:text-white/20 group-hover:text-foreground dark:group-hover:text-white/60 transition-colors duration-700"
                  style={{ 
                    animation: 'spin 20s linear infinite'
                  }}
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </div>
            </div>
          </footer>  
    </section>

  );
};

export default Contact;